/**
 * @file コンポーネント：テキストフォーム スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledInput = styled.input`
    padding: 4px 16px;
    border: 1px solid #868686;
    border-radius: 4px;
    background-color: #ffffff;
    color: #575757;
    font-size: 16px;
    line-height: 32px;

    &:disabled {
        background-color: transparent;
    }

    &::placeholder {
        color: #acadae;
    }

    &:read-only {
        color: #acadae;
    }

    &.is-wide {
        width: 100%;
    }

    .is-ipad.is-safari &::placeholder,
    .is-iphone.is-safari &::placeholder {
        position: relative;
        top: -5px;
    }
`;
